module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921032651_T.eeb171be.jpg";